import themeResource from "../resources/ThemeResource";
import themeStorageResource from "../resources/ThemeStorageResource";

class ThemeDictionary {
  constructor(private _resource) {
  }

  get() {
    return this._resource.get()
      .then((response) => this._processResponse(response))
      .then((data) => {
        themeStorageResource.save(data);
        return data;
      })
      .catch(async (error) => {
        const result = await themeStorageResource.load();
        if (result) {
          return result;
        }
        throw new Error('Load error');
      });
  }

  async _processResponse(response) {
    const responseJson = response && await response.json();
    if (!responseJson) {
      return;
    }

    return responseJson;
  }
}

const themeDictionary = new ThemeDictionary(themeResource);

export default themeDictionary;